import { createContext, useContext } from 'react';

type WarehouseData = {
  warehouseType: string;
  name: string;
};

const WarehouseContext = createContext<WarehouseData>({
  warehouseType: '',
  name: '',
});

export const useWarehouse = () => {
  const ctx = useContext(WarehouseContext);
  return ctx;
};

export const WarehouseProvider = ({ children, warehouseType, name }: any) => {
  return (
    <WarehouseContext.Provider value={{ warehouseType, name }}>
      {children}
    </WarehouseContext.Provider>
  );
};
